import styled from 'styled-components'

export const ClientEditWrapper = styled.div`
  & > div:nth-child(2) {
    display: block;
    float: left;
    margin: 23px 20px 0 0;
  }

  & > h1:nth-child(3) {
    display: block;
    float: left;
  }
`
